import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';
import {showSuccess, ErrorResponse, takeLatestF} from 'favorlogic-utils';

import {handleResponseError} from 'utils/handleResponseError';

import {DeactivateMilkRoomAction, loadSuppliersMilkRooms} from '../actions';
import Api from '../api';

const title = 'Deaktivace mléčnice';

function* handleErrorResponse(response: ErrorResponse): SagaIterator {
    yield* call(handleResponseError, response, title);
}

function* handleSuccessResponse(supplierId: number): SagaIterator {
    yield* put(showSuccess(title, 'Mléčnice byla úspěšně deaktivována'));
    yield* put(loadSuppliersMilkRooms(supplierId));
}

function* execute(action: DeactivateMilkRoomAction): SagaIterator {
    const {milkRoomId, supplierId} = action.payload;
    const response = yield* call(Api.deactivateMilkRoom, milkRoomId);

    yield* response.isSuccess
        ? call(handleSuccessResponse, supplierId)
        : call(handleErrorResponse, response);
}

export function* deactivateMilkRoomSaga(): SagaIterator {
    yield takeLatestF('supplier/DEACTIVATE_MILK_ROOM', execute);
}
